export interface SettingsDomain {
  key: string;
  description: string;
  jsonSchema: Record<string, unknown>;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function readDomains(schema: Record<string, unknown>): SettingsDomain[] {
  const properties = isRecord(schema.properties) ? schema.properties : {};

  return Object.entries(properties).flatMap(([key, jsonSchema]) =>
    isRecord(jsonSchema) && jsonSchema.type === "object"
      ? [{
        key,
        description: typeof jsonSchema.description === "string" ? jsonSchema.description : key,
        jsonSchema,
      }]
      : []);
}
